export default __webpack_public_path__ + "static/media/mandalpatti_trek.d45b2962.jpg";